module.exports = __webpack_public_path__ + "static/media/r21.5449fcb8.jpg";